import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store/index';
import { setRecentlyViewedAction } from '../slice';
import { GettyImagesImageSearchResponseImage } from '../types';

const setRecentlyViewedItemsOperation =
  (recentlyViewedItems: GettyImagesImageSearchResponseImage[]) =>
  async (dispatch: ThunkDispatch<Store, undefined, AnyAction>) => {
    await dispatch(setRecentlyViewedAction(recentlyViewedItems));
  };

export default setRecentlyViewedItemsOperation;
